import React, { Component } from 'react'
import { connect } from 'react-redux'
import uuid from 'uuid/v4'

import Menu from '../../config/menu'
import MenuItem from './menu/Item'
import SingleItem from './menu/SingleItem'

class Sidebar extends Component {
  render () {
    return (
      <aside className='sidebar'>
        {Menu.map((item) => {
          if (item.single) return (
            <SingleItem key={uuid()} icon={item.icon} title={item.title} location={item.location}/>
          )
          return (
            <MenuItem
              key={uuid()}
              icon={item.icon}
              title={item.title}
              children={item.children} />)
        })}
      </aside>
    )
  }
}
// eslint-disable-next-line
Sidebar = connect(state => state.siteReducer)(Sidebar)
export default Sidebar



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/components/core/Sidebar.js